import React, {
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

import {
  PaymentIcon,
} from 'anf-core-react';
import TmntText from '../tmnt-text/tmnt-text';
import { getPaymentIconName } from '../../utils/payment-icon';

export default function RefundMethodDisplay({
  payment,
  email,
  refundMethod,
}) {
  const paymentIcon = useMemo(() => {
    const iconName = getPaymentIconName(payment);
    return (
      <PaymentIcon
        iconName={iconName}
      />
    );
  }, [payment]);

  const creditCardDisplay = useMemo(() => {
    if (payment?.paymentName === 'GIFT_CARD') return null;
    if (refundMethod?.name === 'MC') return null;

    return (
      <div data-testid="refund-method-credit-card">
        <p>
          <span className="dots">•••• •••• ••••</span>
          <span>{payment?.cardNumber.substr(15, 4)}</span>
        </p>
        <p>
          Exp:
          {' '}
          {payment?.cardExpirationDate}
        </p>
      </div>
    );
  }, [payment, refundMethod]);

  const giftCardDisplay = useMemo(() => {
    if (payment?.paymentName !== 'GIFT_CARD') return null;
    if (refundMethod?.name === 'MC') return null;

    return (
      <div data-testid="refund-method-gift-card">
        <p>
          <TmntText k="DRE_EMAILED_TO" className="dots text-bold" />
        </p>
        <p data-testid="refund-method-gift-card-email">
          <span>{email}</span>
        </p>
      </div>
    );
  }, [payment, refundMethod]);

  const merchCreditDisplay = useMemo(() => {
    if (refundMethod?.name !== 'MC') return null;
    return (
      <div data-testid="refund-method-merch-credit">
        <p
          data-testid="refund-method-display-body-text"
        >
          {refundMethod.bodyText}
        </p>
      </div>
    );
  }, [refundMethod]);

  return (
    <div className="refund-method-display">
      {paymentIcon}
      {creditCardDisplay}
      {giftCardDisplay}
      {merchCreditDisplay}
    </div>
  );
}

RefundMethodDisplay.propTypes = {
  email: PropTypes.string.isRequired,
  payment: PropTypes.shape({
    cardType: PropTypes.string,
    cardNumber: PropTypes.string,
    cardExpirationDate: PropTypes.string,
    paymentName: PropTypes.string,
  }).isRequired,
  refundMethod: PropTypes.shape({
    name: PropTypes.string,
    bodyText: PropTypes.string,
  }).isRequired,
};
